/** @format */
import React, { FC } from 'react'
import styled from 'styled-components'

interface DescriptionsProps {
  className?: string
  title?: string
  columns?: number
  children?: React.ReactNode
  extra?: React.ReactNode
}

const Descriptions: FC<DescriptionsProps> = ({ className, title, children, extra }) => {
  return (
    <div className={`${className} ksc_descriptions`}>
      {title || extra ? (
        <div className="ksc_descriptions_header">
          <p className="ksc_descriptions_title">{title}</p>
          {extra ? <div className="ksc_descriptions_extra">{extra}</div> : null}
        </div>
      ) : null}
      <div className="ksc_descriptions_content">{children}</div>
    </div>
  )
}

export default styled(Descriptions)<DescriptionsProps>`
  padding-bottom: 8px;
  .ksc_descriptions_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ksc_descriptions_title {
      width: 40%;
      font-size: 14px;
      font-weight: 700;
    }
    .ksc_descriptions_extra {
      width: 60%;
    }
  }
  .ksc_descriptions_content {
    display: flex;
    flex-wrap: wrap;
    .ksc_descriptions_item {
      width: ${props => `calc(100% / ${props.columns || 3})`};
    }
  }
`
